import { render, staticRenderFns } from "./SamplesTabs.vue?vue&type=template&id=564d393a"
import script from "./SamplesTabs.vue?vue&type=script&lang=js"
export * from "./SamplesTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports